import { THasNexPage } from '../types/hasNexPage';
import { TSearchPromosResponse } from '../types/searchResponse';

export const mapHasNexPage = (promosResponse: TSearchPromosResponse): THasNexPage => {
  const hasNexPage = promosResponse.promoSearchResult.hasMore;

  return hasNexPage || false;
};
